<template>
  <div>
    <head-nav :menuItems="menuItems" />
<div class="seg-content page profile-page">

  <div class="profile">
    <div class="profile-photo">
      <div>
        <img :src="photoLinkR(item.media, 750, 750, 'Fit')" />
      </div>
      <div>
        <img :src="photoLinkR(item.media, 750, 750, 'Fit')" />
      </div>
    </div>
    <div class="profile-details">
      <div class="head">
        <div class="name">{{ item.pubname || (item.firstname+" "+item.lastname) }}</div>
<!--         <div class="role">{{ item.title }}</div> -->
      </div>
      
      <ul class="properties">
<!--         <li>Trained by {{ item.frequency }}</li> -->
<!--         <li>{{ item.experience }} years of experience</li> -->
      </ul>
      <ul class="social">
        <li class="fb" v-if="item.linkFacebook">
          <a :href="extLink(item.linkFacebook)" target="_blank">Facebook</a>
        </li>
        <li class="ig" v-if="item.linkInstagram">
          <a :href="extLink(item.linkInstagram)" target="_blank">Instagram</a>
        </li>
        <li class="tw" v-if="item.linkTwitter">
          <a :href="extLink(item.linkTwitter)" target="_blank">Twitter</a>
        </li>
        <li class="in" v-if="item.linkLinkedin">
          <a :href="extLink(item.linkLinkedin)" target="_blank">LinkedIn</a>
        </li>
      </ul>
    </div>
  </div>
  <div class="teacher-split">
    <div class="videos" v-if="videos.length">
      <h2>Videos</h2>
      <section class="home-list">
        <div class="video hl-wid ww1 wh1 wt0" v-for="item in videos">
          <span class="category">{{ item.type && item.type.title }}</span>
          <span class="language">{{ languages[item.language] }}</span>
          <h2 class="vx">{{ item.title }}</h2>
          <div class="img"><img v-if="item.media" :src="poster(item)" /><a class="play" href=""></a></div>
          <div class="author" v-if="item.author"><img :src="photoLinkR(item.author.media, 512, 512, 'Fit')" />{{ item.author.firstname+" "+item.author.lastname }}</div>
  <!--         <date>{{ formatDate(item.created, "MMM Do, YYYY") }}</date> -->
          <div class="comments">{{ item.comments?item.comments.length:0 }}</div>
          <div class="favs">108</div>
          <router-link :title="item.title" :to="{name: 'content', params: {id: item.id}}" class="wlink"></router-link>
        </div>
      </section>
    </div>
    <div class="description" v-html="formatText(item.pubdesc)"></div>
  </div>


  </div>
</div>
</template>

<script>
import api from './api';
import moment from 'moment';
import mainNav from './mainNav';
import formatters from './formatters';

export default {
  mixins: [mainNav, formatters],
  data: ()=>({
    item: {},
    videos: [],
    playlists: [],
    languages: {
      'English': "en",
      'French': "fr",
      'German': "de",
      'Turkish': "tr",
      'Japanese': "jp",
      'Spanish': "sp",
      'Portuguese': "pt",
    },
  }),
  methods: {
    poster(item) {
      if (item.thumbnail) {
        var media=item.thumbnail;
        if (!media || !media.store || media.store.plugin!="Local")
          return null;
        return media.store.rootUrl+media.path;
      }
      var media=item.media;
      if (media && media.store && media.store.plugin=="Local")
        return media.store.rootUrl+media.path;
      if (!media || !media.store || media.store.plugin!="Video")
        return null;
      return media.store.rootUrl+media.path.replace(/\/[^/]+$/, "/"+media.thumbnail);
    },
    photoLink(media) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return media.store.rootUrl+media.path;
    },
    photoLinkR(media, width, height, mode) {
      if (!media || !media.store || !media.store.rootUrl)
        return null;
      return '/api/Media/'+media.id+'/resize?w='+width+"&h="+height+"&m="+mode;
    },
    extLink(link) {
      if ((link || "").toLowerCase().indexOf("http")!=0)
        return "http://"+link;
      return link;
    },
    extLinkT(link) {
      return (link || "").replace(/^https?:\/\/|\/$/g, "");
    },
    async loadProfile() {
      var items=(await api.list("User", {username: this.$route.params.id})).items;
      if (!items || !items.length)
        return;
      this.item=items[0];
      this.loadVideos();
    },
    async loadVideos() {
      this.videos=(await api.list("Video", {author: this.item.id}, ["id:DESC"])).items;
    },
    formatDate(date, format) {
      return moment(date, "YYYY-MM-DD HH:mm:ss").format(format);
    },
  },
  mounted() {
    this.loadProfile();
    this.menuItems[4].active=true;
  },
}
</script>
